import { Description, Field, Input, Label } from '@headlessui/react'
import type { ComponentProps } from 'react'
import LastUsedBadge from './LastUsedBadge'

type Props = ComponentProps<'input'> & {
  label: string
  error?: string
  lastUsed?: boolean
}

export default function AuthField({ label, error, lastUsed = false, ...props }: Props) {
  return (
    <Field>
      <Label className="mb-2 block text-[15px] font-medium text-stone-900">{label}</Label>
      <span className="relative block">
        <Input
          {...props}
          invalid={Boolean(error)}
          className={`h-11 w-full rounded-lg border bg-white px-3.5 text-base text-stone-900 outline-none placeholder:text-stone-400 focus:ring-2 ${
            error
              ? 'border-red-400 focus:border-red-400 focus:ring-red-100'
              : 'border-stone-200 focus:border-purple-400 focus:ring-purple-100'
          }`}
        />
        {lastUsed && <LastUsedBadge />}
      </span>
      {error && <Description className="mt-1.5 block text-sm text-red-600">{error}</Description>}
    </Field>
  )
}
